import React, {useEffect, useState} from 'react';
import {CSSTransition} from "react-transition-group";
import {texts} from "../../../../translate";
import {createRoundApplication, getRoundApplications, getRoundLimit} from "../../../../utils/api";
import classes from "./limit.module.css";

const Limit = ({lang, data, open, setOpen, setActive, onSpend, onApplied}) => {
    const t = texts[lang].limit
    const [limit, setLimit] = useState(data?.limit)
    const [apps, setApps] = useState([])
    const [showApps, setShowApps] = useState(false)
    const [volume, setVolume] = useState('')
    const [wallet, setWallet] = useState(data?.user?.crypto_address || '')
    const [error, setError] = useState('')
    const [busy, setBusy] = useState(false)

    useEffect(() => {
        if (!open) return
        setWallet(data?.user?.crypto_address || '')
        setError('')
        getRoundLimit().then((res) => {
            if (!res?.error) setLimit(res)
        })
        getRoundApplications().then((res) => {
            if (!res?.error) setApps(res.applications || [])
        })
    }, [open, data?.user?.crypto_address])

    const item = limit || data?.limit || {}
    const openRound = Boolean(data?.open_round)
    const rows = [
        {label: t.base, hint: '', value: item.base || 1000},
        {label: t.invites, hint: `${item.invites || 0} / ${item.invite_cap || 10} · × ${item.invite_each || 2500}`, value: `+${item.invite_bonus || 0}`},
        {label: t.subs, hint: `${item.subscriptions || 0} / ${item.subscription_cap || 20} · × ${item.subscription_each || 500}`, value: `+${item.subscription_bonus || 0}`},
        {label: t.paws, hint: `${item.paws || 0} · ${t.pawHint}`, value: `+${item.paw_bonus || 0}`},
    ]

    const apply = async () => {
        setError('')
        setBusy(true)
        const res = await createRoundApplication(Number(volume), wallet)
        setBusy(false)
        if (res?.error || res?.detail) {
            const code = res.detail || res.error
            setError(t.errors[code] || t.errors.generic)
            return
        }
        setVolume('')
        onApplied?.()
        const next = await getRoundApplications()
        if (!next?.error) setApps(next.applications || [])
        setShowApps(true)
    }

    return (
        <>
            <CSSTransition in={open} timeout={400} classNames="openBonusFon" unmountOnExit>
                <div className={classes.fon} onClick={() => setOpen(false)}/>
            </CSSTransition>
            <CSSTransition in={open} timeout={400} classNames="openBonusMenu" unmountOnExit>
                <div className={classes.sheet}>
                    <div className={classes.handle}/>
                    <div className={classes.title}>{t.title}</div>
                    <p className={classes.intro}>{item.frozen ? t.frozen : t.intro}</p>
                    <div className={classes.card}>
                        {rows.map((row) => (
                            <div className={classes.row} key={row.label}>
                                <div>
                                    <div className={classes.rowLabel}>{row.label}</div>
                                    {row.hint ? <div className={classes.rowHint}>{row.hint}</div> : null}
                                </div>
                                <div className={classes.rowValue}>{row.value}</div>
                            </div>
                        ))}
                    </div>
                    <div className={classes.total}>
                        <div className={classes.totalLabel}>{t.your}</div>
                        <div className={classes.totalValue}>{(item.total || 0).toLocaleString('ru-RU')}</div>
                        <div className={classes.totalHint}>{t.units}</div>
                    </div>
                    {openRound && (
                        <div className={classes.card}>
                            <div className={classes.how}>{t.applyTitle}</div>
                            <input
                                className={classes.input}
                                inputMode="numeric"
                                placeholder={t.volume}
                                value={volume}
                                onChange={(e) => setVolume(e.target.value.replace(/[^\d.]/g, ''))}
                            />
                            <input
                                className={classes.input}
                                placeholder={t.wallet}
                                value={wallet}
                                onChange={(e) => setWallet(e.target.value)}
                            />
                            {error ? <div className={classes.error}>{error}</div> : null}
                            <button type="button" className={classes.primary} disabled={busy} onClick={apply}>
                                {t.apply}
                            </button>
                        </div>
                    )}
                    <div className={classes.card}>
                        <div className={classes.how}>{t.how}</div>
                        <div className={classes.actions}>
                            <button type="button" className={classes.ghost} onClick={() => { setOpen(false); setActive(2) }}>
                                {texts[lang].button.text3}
                            </button>
                            <button type="button" className={classes.ghost} onClick={() => { setOpen(false); setActive(3) }}>
                                {texts[lang].menu.profit}
                            </button>
                        </div>
                        <button type="button" className={classes.ghost} onClick={() => { setOpen(false); onSpend?.() }}>
                            {texts[lang].spend.title}
                        </button>
                    </div>
                    <p className={classes.legal}>{t.hint}</p>
                    <button type="button" className={classes.primary} onClick={() => setShowApps(!showApps)}>
                        {t.apps}{apps.length ? ` · ${apps.length}` : ''}
                    </button>
                    {showApps && (
                        <div className={classes.apps}>
                            {apps.length === 0 ? (
                                <div className={classes.rowHint}>—</div>
                            ) : apps.map((app) => (
                                <div className={classes.appRow} key={app.id}>
                                    <span>#{app.number}</span>
                                    <span>{app.volume}</span>
                                    <span>{app.allocated ?? '—'}</span>
                                    <span>{app.status}</span>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </CSSTransition>
        </>
    )
}

export default Limit
